import { useParams } from 'react-router-dom';
import { useGetLmsNewsByIdQuery } from '../../../../api';

const useLmsNewsDetailData = () => {
    const { id } = useParams();
    const newsId = Number(id);
    const validId = Number.isInteger(newsId) && newsId > 0;

    const { data: news, isLoading, isFetching, isError } = useGetLmsNewsByIdQuery(newsId, { skip: !validId, refetchOnMountOrArgChange: true });

    return {
        news,
        isLoading: validId && (isLoading || (isFetching && !news)),
        notFound: !validId || isError || (!isLoading && !isFetching && !news)
    };
};

export default useLmsNewsDetailData;
